
import { useState, useEffect } from "react";
import CustomLoader from "../../components/CustomLoader/CustomLoader";
import DataTable from "../../components/DataTable/DataTable";
import "./BrokerOnboard.css";
import NoData from "../../components/NoData/NoData";
import Card from '@mui/material/Card';
import { getString } from "../../lang";
import ExportToExcel from "../../components/ExportToExcel/ExportToExcel";
import Button from '@mui/material/Button';
import AddBrokerDialog from "../../components/AddBrokerDialog/AddBrokerDialog";
import BorderColorIcon from '@mui/icons-material/BorderColor';

const BrokerOnboard = () => {

    const [ brokerList, setBrokerList ] = useState(
        {
            isBrokerListLoading: false,
            rows: [
                getString("id"),
                getString("title"),
                getString("broker"),
                getString("domain"),
                getString("status"),
                getString("client_type"),
            ],
            columns: [
                {
                    id: 1,
                    title: "StockAnts",
                    broker: "StockAnts",
                    domain: "https://uat.stockants.com",
                    status: {
                        value: "Active",
                        isTag: true,
                        minWidth: "50px",
                        color: "#4ade80"
                    },
                    client_type: "User Paying"
                },
                {
                    id: 2,
                    title: "Swastika",
                    broker: "Swastika",
                    domain: "https://swastika.stockants.com",
                    status: {
                        value: "Active",
                        isTag: true,
                        minWidth: "50px",
                        color: "#4ade80"
                    },
                    client_type: ""
                },
                {
                    id: 3,
                    title: "Bigul",
                    broker: "Bigul",
                    domain: "https://uat-bigul.stockants.com",
                    status: {
                        value: "Active",
                        isTag: true,
                        minWidth: "50px",
                        color: "#4ade80"
                    },
                    client_type: "User Paying"
                },
                {
                    id: 4,
                    title: "Paytm Money",
                    broker: "Paytm Money",
                    domain: "https://paytmmoney.stockants.com",
                    status: {
                        value: "Active",
                        isTag: true,
                        minWidth: "50px",
                        color: "#4ade80"
                    },
                    client_type: "User Paying"
                },
                {
                    id: 5,
                    title: "AngelOne",
                    broker: "AngelOne",
                    domain: "https://angelone.stockants.com",
                    status: {
                        value: "Active",
                        isTag: true,
                        minWidth: "50px",
                        color: "#4ade80"
                    },
                    client_type: "User Paying"
                },
                {
                    id: 6,
                    title: "Nirman",
                    broker: "Nirman",
                    domain: "https://nirman.stockants.com",
                    status: {
                        value: "Inactive",
                        isTag: true,
                        minWidth: "50px",
                        color: "#ff4560"
                    },
                    client_type: "User Paying"
                }
            ],
            excelColumns: []
        }
    );

    const [ isAddBrokerDialogVisible, setAddBrokerDialogVisible ] = useState(false);

    useEffect(() => {
        let excelColumns = brokerList.columns.map(el => ([
            el.id,
            el.title,
            el.broker,
            el.domain,
            el.status,
            el.client_type,
        ]));

        setBrokerList(prev => ({
            ...prev,
            excelColumns: excelColumns
        }));
    }, [])

    const handleActionClick = (rowData, index) => {
        console.log("Edit clicked for row:", rowData, "at index:", index);
        // Add your edit logic here
    };

    return (
        <div className="main-container">
            <div className="px-4 py-4">
                <div className="text-right mb-4">
                    <Button size="small" variant="contained" className="sm-btn btn-filled" onClick={ () => setAddBrokerDialogVisible(true) }>{ getString("add_broker") }</Button>

                    <AddBrokerDialog isVisible = { isAddBrokerDialogVisible } onClose={() => setAddBrokerDialogVisible(false)}></AddBrokerDialog>
                </div>
                
                <Card className='card-container p-2'>
                    <div className="text-[16px] font-semibold m-2 card-title-color flex justify-between items-center">
                        { getString("broker_list") }

                        { (brokerList.rows && brokerList.columns) && <ExportToExcel excelRows={ brokerList.rows } excelColumns={ brokerList.excelColumns } excelName={ getString("broker_list") } /> }
                    </div>
                    
                    {
                        brokerList.isBrokerListLoading ? <CustomLoader noLines={[1,2,3,4,5]} variant="text" animation="wave" fontSize='2rem'></CustomLoader> : 
                        
                        brokerList.rows.length && brokerList.columns.length ? 
                        
                        <div className="row-top-margin">
                            <DataTable 
                                columns={ brokerList.columns } 
                                row= { brokerList.rows } 
                                excelColumns={ brokerList.excelColumns }
                                actionIcon={<BorderColorIcon />}
                                onActionClick={ handleActionClick }
                            ></DataTable>
                        </div> :
                        
                        <NoData />
                    }
                </Card>
            </div>
        </div>
    );
}

export default BrokerOnboard;